import { useCallback, useEffect, useMemo, useState } from 'react'
import { Store } from 'core/models/store'
import SelectCountry from '../upward-forecast/select-country'
import { SelectStore } from '../upward-forecast/data-manager/form/store-cell'
import React from 'react'
import { useTranslation } from 'react-i18next'

export interface IFavoriteStoreFieldProps {
  onAddFavoriteStores: (value: number[]) => void
  disabledItemsIds?: number[]
  storeList: Store[]
}

const FavoriteStoreFields: React.FunctionComponent<IFavoriteStoreFieldProps> = ({
  onAddFavoriteStores,
  disabledItemsIds,
  storeList
}) => {
  const { t } = useTranslation()
  const defaultCountry = useMemo(() => storeList?.[0]?.country_id ?? null, [storeList])
  const [country, setCountry] = useState<string>(defaultCountry)
  const [favoriteStoresIds, setFavoriteStoresIds] = useState<number[]>([])

  useEffect(() => {
    setCountry(defaultCountry)
  }, [defaultCountry])

  const handleCountryChange = useCallback((value: string) => {
    setCountry(value)
    setFavoriteStoresIds([])
  }, [])

  const handleStoreChange = (storesIds: number[]) => {
    setFavoriteStoresIds(storesIds)
  }

  const handleValidation = useCallback(() => {
    onAddFavoriteStores(favoriteStoresIds)
    setFavoriteStoresIds([])
  }, [onAddFavoriteStores, favoriteStoresIds])

  return (
    <div className="favorite-stores-fields">
      <SelectCountry value={country} onChange={handleCountryChange} />
      {country ? (
        <div className="mg-select-and-button-wrapper">
          <SelectStore
            id="user-preferences_select_store"
            storeId={favoriteStoresIds}
            countryId={country}
            onChange={handleStoreChange}
            hasBottomLine
            disabledItemsIds={disabledItemsIds}
            isMultiple
          />
          <button
            type="button"
            data-testid="filters-add-btn"
            className="vtmn-btn vtmn-btn_variant--primary vtmn-btn_size--small"
            onClick={handleValidation}
            disabled={favoriteStoresIds.length === 0}
          >
            {t('add')}
          </button>
        </div>
      ) : null}
    </div>
  )
}
export default FavoriteStoreFields
